import { render, staticRenderFns } from "./SecretQuestions.vue?vue&type=template&id=10dfa8e3&"
import script from "./SecretQuestions.vue?vue&type=script&lang=js&"
export * from "./SecretQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports